import AdultSymptomExercisePage from '@/components/AdultSymptomExercisePage';
import { isAdultExerciseGroup } from '@/lib/data/contentCatalog';
import { createFileRoute } from '@tanstack/react-router'
import ExerciseImage from "@/assets/exercise-background-photos/sleeping.jpg";
import sleepVideo1Mp4 from '@/assets/videos/adults-symptoms/sleep/sleep-problems-part-1.mp4';
import sleepVideo1Webm from '@/assets/videos/adults-symptoms/sleep/sleep-problems-part-1.webm';
import sleepVideo2Mp4 from '@/assets/videos/adults-symptoms/sleep/sleep-problems-part-2.mp4';
import sleepVideo2Webm from '@/assets/videos/adults-symptoms/sleep/sleep-problems-part-2.webm';
import sleepPoster from '@/assets/sleep-poster.png';
import sleepPart1Ar from '/subs/sleep-problems-part-1.ar.vtt';
import sleepPart1En from '/subs/sleep-problems-part-1.en.vtt';
import sleepPart2Ar from '/subs/sleep-problems-part-2.ar.vtt';
import sleepPart2En from '/subs/sleep-problems-part-2.en.vtt';
import { useLocaleStore } from '@/lib/stores/localeStore';

export const Route = createFileRoute('/(content)/adults/exercises/sleep/')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    group: isAdultExerciseGroup(search.group) ? search.group : undefined,
    mode: (search.mode === 'videos' || search.mode === 'exercises') ? search.mode as 'videos' | 'exercises' : undefined,
  }),
head: () => ({
    meta: [
      {
        title: "Sleep - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "sleep.title",
    navbar: {
      transparent: true,
      showTitle: false,
    },
  }),
});

function RouteComponent() {
  const { group, mode } = Route.useSearch();
  const navigate = Route.useNavigate();
  const locale = useLocaleStore((state) => state.locale);
  const captionsDir: 'ltr' | 'rtl' = locale === 'ar' ? 'rtl' : 'ltr';
  const videos = [
    {
      sources: [
        { src: sleepVideo1Webm, type: 'video/webm' },
        { src: sleepVideo1Mp4, type: 'video/mp4' },
      ],
      subtitleTracks: [
        { src: sleepPart1Ar, srcLang: 'ar', label: 'Arabic', default: true },
        { src: sleepPart1En, srcLang: 'en', label: 'English' },
      ],
      activeSubtitleLanguage: locale === 'ar' ? 'ar' : 'en',
      captionsDir,
      defaultCaptionsVisible: true,
      showCaptionsToggle: true,
    },
    {
      sources: [
        { src: sleepVideo2Webm, type: 'video/webm' },
        { src: sleepVideo2Mp4, type: 'video/mp4' },
      ],
      subtitleTracks: [
        { src: sleepPart2Ar, srcLang: 'ar', label: 'Arabic', default: true },
        { src: sleepPart2En, srcLang: 'en', label: 'English' },
      ],
      activeSubtitleLanguage: locale === 'ar' ? 'ar' : 'en',
      captionsDir,
      defaultCaptionsVisible: true,
      showCaptionsToggle: true,
    },
  ];

  return (
    <AdultSymptomExercisePage
      symptom="sleep"
      titleKey="sleep.title"
      heroImage={ExerciseImage}
      poster={sleepPoster}
      videos={videos}
      mode={mode}
      onModeChange={(nextMode) =>
        navigate({
          to: Route.to,
          search: {
            mode: nextMode ?? undefined,
            group: nextMode === 'exercises' ? group : undefined,
          },
        })
      }
      selectedGroup={group}
      onSelectGroup={(nextGroup) =>
        navigate({
          to: Route.to,
          search: { mode: 'exercises', group: nextGroup },
        })
      }
      navButtonColor="text-dark-gray/60"
      skipButtonBgColor="bg-dark-gray/40"
    />
  );
}
